import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=a2d9ee38&"
import script from "./UploadPicture.vue?vue&type=script&lang=js&"
export * from "./UploadPicture.vue?vue&type=script&lang=js&"
import style0 from "./UploadPicture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports